import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import cellEditFactory from "react-bootstrap-table2-editor";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory from "react-bootstrap-table2-filter"; // textFilter, selectFilter, dateFilter, numberFilter, Comparator,
require("react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css");
import "assets/css/material-dashboard-react.css";
import "./admindashboard.css";
// react plugin for creating charts
// import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
import {
  Accordion,
  Row,
  Col,
  Form,
  Button,
  FormControl,
} from "react-bootstrap";
// import { CSVLink } from "react-csv";
// const { SearchBar } = Search;
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import {
  // Warning,
  // DateRange,
  // LocalOffer,
  // Update,
  // ArrowUpward,
  // Accessibility,
  // BugReport,
  // Code,
  // AssignmentTurnedIn,
  // Announcement,
  AccountBalance,
  AccessTime,
  Group,
  Person,
  // LiveHelp,
  // ShowChart,
} from "@material-ui/icons/";
// import {
//   Agriculture,
// } from "@mui/icons-material";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Tasks from "components/Tasks/Tasks.js";
// import CustomTabs from "components/CustomTabs/CustomTabs.js";
// import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// import { bugs, website, server } from "variables/general.js";
import ModalViewAssoc from "./modalViewAssoc";
import ModalViewContract from "./modalViewContract";

import // dailySalesChart,
// emailsSubscriptionChart,
// completedTasksChart,
"variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/AdmindashboardStyle.js";
// import { Icon } from "@material-ui/core";
import dashboardService from "../../services/dashboard.service";
//Import Loading
import Spinner from "react-bootstrap/Spinner";
import LoadingAlert from "../../components/LoadingAlert";

const useStyles = makeStyles(styles);

export default function OcsbDashboard() {
  const [loading, setLoading] = useState(false);
  // const [loadingAlert, setLoadingAlert] = useState(false);
  const [error, setError] = useState(false);
  // const [regdata, setRegdata] = useState([]);
  const [dopadata, setDopadata] = useState([]);
  const [assocmember, setAssocmember] = useState([]);
  const [farmerdata, setFarmerdata] = useState([]);
  const [search, setSearch] = useState({});
  const [assocdata, setAssocdata] = useState([]);
  const [contractdata, setContractdata] = useState([]);
  const [show_assoc, setShow_assoc] = useState(false);
  const [show_contract, setShow_contract] = useState(false);

  const { ExportCSVButton } = CSVExport;

  useEffect(() => {
    // getRegdata();
    getDopadata();
    getAssocmember();
    // getFarmerdata();
  }, []);

  // const getRegdata = () => {
  //   dashboardService
  //     .getSumByRegistration()
  //     .then((response) => {
  //       // console.log(response.data.data);
  //       setRegdata(response.data.data[0]);
  //       // console.log(regdata);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching data: ", error);
  //       setError(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const getDopadata = () => {
    dashboardService
      .getSumByDopa()
      .then((response) => {
        // console.log(response.data.data);
        console.log(response.data);
        setDopadata(response.data.data[0]);
        // console.log(dopadata);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAssocmember = () => {
    dashboardService
      .getSumByAssocMembers()
      .then((response) => {
        // console.log(response.data.data);
        setAssocmember(response.data.data[0]);
        // console.log(assocmember);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getFarmerdata = () => {
    setLoading(true);
    dashboardService
      .getOcsbFarmers(search)
      .then((response) => {
        // console.log(response.data.data);
        setFarmerdata(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clickViewAssoc = (id) => {
    console.log(id);
    setAssocdata([]);
    setLoading(true);
    dashboardService
      .getAssocByFarmer(id)
      .then((response) => {
        console.log(response.data.data);
        setAssocdata(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
    setShow_assoc(true);
  };

  const ActionsViewAssoc = (cell, row) => {
    // console.log(row);
    return (
      <>
        <a onClick={() => clickViewAssoc(row.personcardid)}>{cell}</a>
      </>
    );
  };

  // const clickViewContract = (id) => {
  //   console.log(id);
  //   dashboardService
  //     .getContractByFarmer(id)
  //     .then((response) => {
  //       console.log(response.data.data);
  //       setContractdata(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching data: ", error);
  //       setError(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  //   setShow_contract(true);
  // };

  // const actionsViewContract = (cell, row) => {
  //   console.log(row);
  //   return (
  //     <>
  //       <div onClick={() => clickViewContract(row.personcardid)}>{cell}</div>
  //     </>
  //   );
  // };

  // let pie_farmerStatus = {
  //   labels: [
  //     // "ขาดส่ง (" + parseInt(assocmember.no3yr).toLocaleString("en") + ")",
  //     "ปกติ (" + parseInt(assocmember.goodid).toLocaleString("en") + ")",
  //     "รอตรวจสอบ (" + parseInt(assocmember.badid).toLocaleString("en") + ")",
  //   ],
  //   series: [
  //     // {
  //     //   name: "no3yr",
  //     //   value: 0, //assocmember.no3yr
  //     //   className: "ct-series-c",
  //     // },
  //     {
  //       name: "goodid",
  //       value: assocmember.goodid,
  //       className: "ct-series-a",
  //     },
  //     {
  //       name: "badid",
  //       value: assocmember.badid,
  //       className: "ct-series-b",
  //     },
  //   ],
  //   total: assocmember.members,
  // };

  // let pie_approveStatus = {
  //   labels: [
  //     "อนุมัติ\r\n(" + parseInt(regdata.approved).toLocaleString("en") + ")",
  //     "รออนุมัติ\r\n(" + parseInt(regdata.suspended).toLocaleString("en") + ")",
  //     // "ไม่ขึ้นทะเบียน\r\n(" +
  //     //   parseInt(data.unregistered).toLocaleString("en") +
  //     //   ")",
  //   ],
  //   series: [
  //     {
  //       name: "approved",
  //       label: parseInt(regdata.approved).toLocaleString("en"),
  //       value: regdata.approved,
  //       className: "ct-series-e",
  //     },
  //     {
  //       name: "suspended",
  //       label: parseInt(regdata.suspended).toLocaleString("en"),
  //       value: regdata.suspended,
  //       ignoreEmptyValues: true,
  //       className: "ct-series-c",
  //     },
  //   ],
  //   total: regdata.registered,
  // };

  // let pie_approveDopa = {
  //   labels: [
  //     "มีชีวิต (" + parseInt(dopadata.alive).toLocaleString("en") + ")",
  //     "เสียชีวิต (" + parseInt(dopadata.dead).toLocaleString("en") + ")",
  //     // "ระบุไม่ได้ (" +
  //     //   parseInt(dopadata.dopa_unknown).toLocaleString("en") +
  //     //   ")",
  //   ],
  //   series: [
  //     {
  //       name: "alive",
  //       value: dopadata.alive,
  //       className: "ct-series-d",
  //     },
  //     {
  //       name: "dead",
  //       value: dopadata.dead,
  //       className: "ct-series-f",
  //     },
  //   ],
  //   total: dopadata.farmers,
  // };

  // let pie_options = {
  //   startAngle: 0,
  //   donut: false,
  //   width: "400px",
  //   height: "400px",
  //   showLabel: true,
  //   labelPosition: "inside",
  //   labelDirection: "neutral", // neutral, explode
  //   labelOffset: 80,
  //   chartPadding: 80,
  //   style: { wordwrap: "break-word" },
  //   // labelInterpolationFnc: function (value) {
  //   //   return Math.round((value / data.series.reduce(sum)) * 100) + "%";
  //   // },
  //   // responsiveOptions,
  //   // Override the class names that are used to generate the SVG structure of the chart
  //   classNames: {
  //     chartPie: "ct-chart-pie",
  //     chartDonut: "ct-chart-donut",
  //     series: "ct-series",
  //     slicePie: "ct-slice-pie",
  //     sliceDonut: "ct-slice-donut",
  //     sliceDonutSolid: "ct-slice-donut-solid",
  //     label: "ct-label-pie",
  //   },
  // };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const regStatus = [
    { value: "ชาวไร่", label: "เป็นชาวไร่อ้อย" },
    { value: "ลาออก", label: "ลาออก" },
    { value: "พ้นสภาพ", label: "พ้นสภาพ" },
    { value: "-", label: "ไม่ได้จดทะเบียน" },
  ];

  const optionMaster = [
    { value: "หน.กลุ่ม", label: "หน.กลุ่ม" },
    { value: "สมาชิก", label: "สมาชิก" },
  ];

  const optionDopa = [
    { value: "TRUE", label: "มีชีวิต" },
    { value: "FALSE", label: "เสียชีวิต" },
  ];

  const cellFormatter = (cell) => {
    if (cell == "มีชีวิต" || cell == "ชาวไร่") {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "เสียชีวิต" || cell == "พ้นสภาพ") {
      return <p className="text-danger">{cell}</p>;
    }
  };

  const dateFormatter = (cell, row) => {
    // console.log(row);
    // if (row.createdat !== "1984-06-29T17:00:00.000Z") {
    const getdate = new Date(cell);
    return row.createdat !== null ? (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    ) : (
      <p>-</p>
    );
    // }
  };

  // const dateFilter = dateFilter({
  //   delay: 600, // how long will trigger filtering after user typing, default is 500 ms
  //   placeholder: "custom placeholder", // placeholder for date input
  //   withoutEmptyComparatorOption: true, // dont render empty option for comparator
  //   comparators: [Comparator.EQ, Comparator.GT, Comparator.LT], // Custom the comparators
  //   style: { display: "inline-grid" }, // custom the style on date filter
  //   className: "custom-dateFilter-class", // custom the class on date filter
  //   comparatorStyle: { backgroundColor: "antiquewhite" }, // custom the style on comparator select
  //   comparatorClassName: "custom-comparator-class", // custom the class on comparator select
  //   dateStyle: { backgroundColor: "cadetblue", margin: "0px" }, // custom the style on date input
  //   dateClassName: "custom-date-class", // custom the class on date input
  //   defaultValue: { date: new Date(2018, 0, 1), comparator: Comparator.GT }, // default value
  //   // id: 'id', // assign a unique value for htmlFor attribute, it's useful when you have same dataField across multiple table in one page
  // });

  const handleSearch = (e) => {
    e.preventDefault();
    getFarmerdata();
    // getAssocdata();
    // getContractdata();
  };

  const setField = (field, value) => {
    console.log(search);
    setSearch({
      ...search,
      [field.name]: value,
    });
  };

  const table_columns = [
    {
      text: "key",
      dataField: "personcardid",
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "personcardid",
      text: "บัตรประชาชน",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      sort: true,
      editable: false,
    },
    {
      dataField: "farmer_card_id",
      text: "เลขชาวไร่",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      sort: true,
      editable: false,
    },
    {
      dataField: "farmername",
      text: "เกษตรกร",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "15%" };
      },
      sort: true,
      editable: false,
      style: {
        textAlign: "left",
      },
    },
    {
      dataField: "farmeraddress",
      text: "ที่อยู่",
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "15%" };
      },
      style: {
        textAlign: "left",
      },
      sort: true,
    },
    {
      dataField: "assocsigned",
      text: "สมาคม",
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "8%" };
      },
      formatter: ActionsViewAssoc,
      // filter: numberFilter({
      //   placeholder: "จำนวนสมาคม",
      //   style: {
      //     textAlign: "center",
      //     fontSize: "98%",
      //     // width: "100px",
      //     // marginRight: "-10rem",
      //     // display: "absolute",
      //   },
      //   comparators: [
      //     Comparator.LT,
      //     Comparator.LE,
      //     Comparator.EQ,
      //     Comparator.GE,
      //     Comparator.GT,
      //   ],
      //   comparatorStyle: {
      //     width: "auto",
      //     fontSize: "95%",
      //     backgroundColor: "#c5c4c4",
      //   },
      //   defaultValue: { number: 0, comparator: Comparator.GE },
      // }),
      sort: true,
    },
    // {
    //   dataField: "contractsigned",
    //   text: "คู่สัญญา",
    //   headerSortingStyle,
    //   editable: false,
    //   headerStyle: () => {
    //     return {
    //       verticalAlign: "middle",
    //       width: "8%",
    //       padding: ".375rem .5rem",
    //     };
    //   },
    //   sort: true,
    // },
    {
      dataField: "membertype",
      text: "หน.กลุ่ม",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "7%" };
      },
      sort: true,
      editable: false,
    },
    {
      dataField: "farmerstatus",
      text: "การมีชีวิต",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "7%" };
      },
      formatter: cellFormatter,
      sort: true,
      editable: false,
    },
    {
      dataField: "regstatus",
      text: "ชาวไร่",
      headerSortingStyle,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "7%" };
      },
      sort: true,
      editable: false,
    },
    {
      dataField: "createdat",
      text: "จดทะเบียนชาวไร่",
      formatter: dateFormatter,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "8%" };
      },
      // filter: dateFilter({
      //   style: {
      //     textAlign: "center",
      //     fontSize: "98%",
      //     width: "auto",
      //     // marginRight: "-2rem",
      //     display: "absolute",
      //   },
      //   comparators: [
      //     Comparator.LT,
      //     Comparator.LE,
      //     Comparator.EQ,
      //     Comparator.GE,
      //     Comparator.GT,
      //   ],
      //   comparatorStyle: {
      //     width: "auto",
      //     fontSize: "95%",
      //     backgroundColor: "#c5c4c4",
      //   },
      //   defaultValue: { comparator: Comparator.LE },
      // }),
      sort: true,
    },
  ];

  // const headers = [
  //   ...table_columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const classes = useStyles();

  // if (loading)
  //   return (
  //     <>
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
  //       </p>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      {/* {loading ? <LoadingAlert /> : ""} */}
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h4>สรุปภาพรวม</h4>
          </Accordion.Header>
          <Accordion.Body>
            <h5>ข้อมูลการเป็นสมาขิกสมาคม</h5>
            <GridContainer>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="success" stats icon>
                    <CardIcon color="success">
                      <AccountBalance />
                    </CardIcon>
                    <h2 className={classes.cardCategory}>สมาคม</h2>
                    <h3 className={classes.cardTitle}>
                      {assocmember.association ? (
                        parseInt(assocmember.association).toLocaleString("en")
                      ) : (
                        <Spinner animation="border" variant="success" />
                      )}
                      &nbsp;<small> แห่ง</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                      Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="info" stats icon>
                    <CardIcon color="info">
                      {/* <Icon>{Person}</Icon> */}
                      <Person />
                    </CardIcon>
                    <h2 className={classes.cardCategory}>หัวหน้ากลุ่ม</h2>
                    <h3 className={classes.cardTitle}>
                      {assocmember.grouphead ? (
                        parseInt(assocmember.grouphead).toLocaleString("en")
                      ) : (
                        <Spinner animation="border" variant="info" />
                      )}
                      &nbsp;<small>ราย</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <Danger>
                        <Warning />
                      </Danger>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Get more space
                      </a> */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="warning" stats icon>
                    <CardIcon color="warning">
                      {/* <Accessibility /> */}
                      <AccessTime />
                    </CardIcon>
                    <h2 className={classes.cardCategory}>ขาดส่ง</h2>
                    <h3 className={classes.cardTitle}>
                      {assocmember.no3yr ? (
                        parseInt(assocmember.no3yr).toLocaleString("en")
                      ) : (
                        <Spinner animation="border" variant="success" />
                      )}
                      &nbsp;<small>ราย</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <Update />
                      Just Updated */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </Accordion.Body>
          {/* <Accordion.Body>
            <h5>ข้อมูลการขึ้นทะเบียน</h5>
            <GridContainer>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="info" stats icon>
                    <CardIcon color="info">
                      <Group />
                    </CardIcon>
                    <p className={classes.cardCategory}>ขึ้นทะเบียน</p>
                    <h3 className={classes.cardTitle}>
                      {parseInt(regdata.registered).toLocaleString("en")}
                      &nbsp;<small> ราย</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}></div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="success" stats icon>
                    <CardIcon color="success">
                      <Accessibility />
                      <AssignmentTurnedIn />
                    </CardIcon>
                    <p className={classes.cardCategory}>อนุมัติ</p>
                    <h3 className={classes.cardTitle}>
                      {parseInt(regdata.approved).toLocaleString("en")}
                      &nbsp;<small>ราย</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <Update />
                      Just Updated
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader color="warning" stats icon>
                    <CardIcon color="warning">
                      <Icon>{Person}</Icon>
                      <LiveHelp />
                    </CardIcon>
                    <p className={classes.cardCategory}>รออนุมัติ</p>
                    <h3 className={classes.cardTitle}>
                      {parseInt(regdata.suspended).toLocaleString("en")}
                      &nbsp;<small> ราย</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <Danger>
                        <Warning />
                      </Danger>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Get more space
                      </a>
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </Accordion.Body> */}
          {/* <Accordion.Body>
            <h5>แผนภาพสรุป</h5>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6} align="center">
                <ChartistGraph
                  data={pie_farmerStatus}
                  options={pie_options}
                  type="Pie"
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6} align="center">
                <ChartistGraph
                  data={pie_approveDopa}
                  options={pie_options}
                  type="Pie"
                />
              </GridItem>
            </GridContainer>
          </Accordion.Body> */}
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <h4>ข้อมูลเกษตรกร</h4>
          </Accordion.Header>
          <Accordion.Body>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} align="center">
                <Group />
                <h5>
                  จำนวนชาวไร่อ้อย ณ ปัจจุบัน &nbsp;
                  {parseInt(dopadata.farmers).toLocaleString("en")}
                  &nbsp;ราย
                </h5>
                <div className={classes.stats}></div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ModalViewAssoc
                  show={show_assoc}
                  data={assocdata}
                  setdata={(b) => setAssocdata(b)}
                  hidden={(a) => setShow_assoc(a)}
                />
                <ModalViewContract
                  show={show_contract}
                  data={contractdata}
                  setdata={(b) => setContractdata(b)}
                  hidden={(a) => setShow_contract(a)}
                />
                <ToolkitProvider
                  bootstrap4
                  keyField="personcardid"
                  data={farmerdata}
                  columns={table_columns}
                  search
                  exportCSV={{
                    fileName: "ข้อมูลเกษตรกร.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
                    separator: ",",
                    ignoreHeader: false,
                    noAutoBOM: false,
                    blobType: "text/plain;charset=utf-8",
                    onlyExportFiltered: true,
                    exportAll: false,
                  }}
                >
                  {(prop) => (
                    <React.Fragment>
                      <div>
                        <div className="text-left">
                          <Row>
                            <Col md={11}>
                              <Form className="d-flex">
                                <Col md={11}>
                                  <Row>
                                    <Col md={4}>
                                      <Form.Select
                                        size="sm"
                                        name="regSearch"
                                        value={search.regSearch}
                                        // onChange={handleSearchStatusChange}
                                        onChange={(e) =>
                                          setField(e.target, e.target.value)
                                        }
                                      >
                                        <option value="">
                                          -- ชาวไร่อ้อย --
                                        </option>
                                        {regStatus.map((o) => (
                                          <option key={o.value} value={o.value}>
                                            {o.label}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                    <Col md={4}>
                                      <Form.Select
                                        size="sm"
                                        name="masterSearch"
                                        value={search.masterSearch}
                                        // onChange={handleSearchMasterChange}
                                        onChange={(e) =>
                                          setField(e.target, e.target.value)
                                        }
                                      >
                                        <option value="">
                                          -- หน.กลุ่ม / สมาชิก --
                                        </option>
                                        {optionMaster.map((o) => (
                                          <option key={o.value} value={o.value}>
                                            {o.label}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                    <Col md={4}>
                                      <Form.Select
                                        size="sm"
                                        name="dopaSearch"
                                        value={search.dopaSearch}
                                        // onChange={handleSearchDopaChange}
                                        onChange={(e) =>
                                          setField(e.target, e.target.value)
                                        }
                                      >
                                        <option value="">
                                          -- มีชีวิต / เสียชีวิต --
                                        </option>
                                        {optionDopa.map((o) => (
                                          <option key={o.value} value={o.value}>
                                            {o.label}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={12}>
                                      <FormControl
                                        size="sm"
                                        name="textSearch"
                                        value={search.textSearch}
                                        type="search"
                                        placeholder="ชื่อ-สกุล, บัตรประชาชน"
                                        aria-label="Search"
                                        // onChange={handleSearchChange}
                                        onChange={(e) =>
                                          setField(e.target, e.target.value)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col md={1}>
                                  <Button
                                    className="btn btn-info"
                                    onClick={handleSearch}
                                    style={{
                                      padding: ".375rem .75rem",
                                      fontSize: "1.5rem",
                                    }}
                                  >
                                    <i className="bi bi-search"></i>
                                  </Button>
                                </Col>
                              </Form>
                            </Col>
                            <Col md={1}>
                              {/* <CSVLink
                                data={farmerdata}
                                headers={[
                                  ...headers.filter(
                                    (a) => a.csvExport !== false
                                  ),
                                ]}
                                filename={"ข้อมูลเกษตรกร.csv"}
                                className="btn btn-success"
                                target="_blank"
                                style={{
                                  padding: ".375rem .75rem",
                                  fontSize: "1rem",
                                  float: "right",
                                }}
                              >
                                <i className="bi bi-download"></i>
                              </CSVLink> */}
                              <ExportCSVButton
                                {...prop.csvProps}
                                style={{
                                  padding: ".375rem .75rem",
                                  fontSize: "1.5rem",
                                  float: "right",
                                }}
                              >
                                <i className="bi bi-download"></i>
                              </ExportCSVButton>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <hr />
                      <CardBody>
                        {loading ? <LoadingAlert /> : ""}
                        <BootstrapTable
                          bootstrap4
                          keyField="personcardid"
                          columns={table_columns}
                          data={farmerdata}
                          pagination={pagination}
                          filter={filterFactory()}
                          // loading={true}
                          {...prop.baseProps}
                          // cellEdit={cellEditFactory({
                          //   mode: "click",
                          //   blurToSave: true,
                          //   afterSaveCell: handleChange,
                          //   beforeSaveCell: beforeSaveCell,
                          // })}
                        />
                      </CardBody>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </GridItem>
            </GridContainer>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
